<template>
  <!-- было потрачено 150 мин -->
  <div class="tw-px-[26px] tw-py-[15px] tw-bg-bgPage">
    <ul
      class="tw-flex tw-list-none tw-relative tw-justify-center tw-p-0 tw-m-0"
    >
      <li
        v-if="menuData"
        v-for="(item, index) in menuData"
        :key="index"
        :menu="setMenu(item)"
        class="tw-max-w-[320px] tw-group tw-list-none tw-grow tw-relative"
      >
        <div
          class="tw-flex tw-items-center tw-justify-center tw-py-[8px] tw-gap-[10px] --tw-px-[50px] hover:tw-bg-warning group-hover:tw-bg-warning tw-text-[15px] tw-leading-[125%] tw-rounded-[8px]"
        >
          <span class="tw-hidden xl:tw-inline">
            ({{ item.menu__number }})
          </span>
          {{ dataLang[item.menu__item] }}
          <img
            :src="require(`@/assets/header-icons/arrow.svg`)"
            class="tw-h-[5px] group-hover:tw-rotate-[180deg] tw-duration-300"
          />
        </div>

        <div
          class="tw-pt-[12px] tw-absolute tw-hidden group-hover:tw-block"
          :class="{
            'group-last:tw-right-0': menuData?.length > 3,
          }"
        >
          <ul
            class="tw-max-h-[calc(100vh-150px)] tw-overflow-y-auto tw-list-none tw-bg-white tw-flex tw-flex-col tw-text-[14px] tw-shadow-[0_6px_12px_0_rgba(0,0,0,0.1),0_-1px_1px_0_rgba(0,0,0,0.05)] tw-border-0 tw-border-t-[3px] tw-border-solid tw-border-warning tw-py-[10px] tw-px-[20px] tw-w-[320px] tw-rounded-[5px]"
          >
            <li
              @click="closeMenu"
              vfor="(children, idx) in item.children"
              v-for="(children, idx) in specialComputed(item)"
              :key="children.menu__id"
              :submenu="setMenu(children)"
              class="tw-list-none"
              v-if="Boolean(children.menu__is_active) && children.menu__href"
              :class="{
                'tw-pointer-events-none':
                  children.menu__css_class == 'grey' ||
                  ['804', '809', '810'].includes(children.menu__number),
              }"
            >
              <router-link
                :to="{ path: children.menu__href }"
                class="!tw-text-forTitle tw-py-[6px] tw-flex tw-justify-between tw-items-center hover:tw-underline"
              >
                <span
                  :class="{
                    'tw-opacity-[0.15] tw-pointer-events-none':
                      children.menu__css_class == 'grey' ||
                      ['804', '809', '810'].includes(children.menu__number),
                  }"
                >
                  <span v-if="item.menu__id != 11">
                    ({{ children.menu__number }})
                    {{ dataLang[children.menu__item] }}
                  </span>
                  <span v-else>
                    ({{ children.menu__number }})
                    {{ children.menu__description }}
                  </span>
                </span>
                <span
                  v-if="isRepair(children.menu__number)"
                  class="!tw-text-green-600 tw-ml-[20px]"
                >
                  (Обновляем раздел)
                </span>
                <span
                  v-if="isComing(children.menu__number)"
                  class="!tw-text-green-600 tw-ml-[20px]"
                >
                  (2027)
                </span>
                <span v-if="isExternal(children.menu__number)" class="">
                  <img
                    :src="require(`@/assets/icons/external.svg`)"
                    class="tw-h-[16px] tw-w-[16px]"
                  />
                </span>
              </router-link>
            </li>
          </ul>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
import ClickOutside from "@/directives/click-outside.js";
import AboutUser from "@/api/AboutUser.js";
import { get } from "lodash";
// import simplebar from 'simplebar-vue';
// import 'simplebar/dist/simplebar.min.css';
export default {
  props: ["openMenu"],
  components: {},
  data() {
    return {
      aboutUser: {},
      countNumber: 0,
    };
  },

  methods: {
    ...mapActions("menuModule", ["getAll", "setMenuByKey"]),
    specialComputed(item) {
      if (item.menu__id != 11) return item.children;
      if (item.menu__id == 11) return this.specialCrutch;
    },
    isRepair(id) {
      return ["101", "102", "103", "201"].includes(id);
    },
    isComing(id) {
      return ["402", "403"].includes(id);
    },
    isExternal(id) {
      return ["504"].includes(id);
    },
    closeMenu() {
      this.$emit("closeMenu");
      this.updateUserInfo();
    },
    skip(e) {
      e.preventDefault();
    },
    openSubMenu(index) {
      if (window.innerWidth < 992) {
        let item = this.menuData[index];

        item.active = !item.active;
        this.$set(this.menuData, index, item);
      }
    },
    closeSubMenu() {
      this.menuData.forEach((element) => {
        this.$delete(element, "active");
      });
    },

    setMenu(item) {
      this.setMenuByKey(item);
      return true;
    },
    signOut() {
      localStorage.removeItem("user-token");
      localStorage.removeItem("translations");
      this.$router.push("/auth");
    },
    updateUserInfo() {
      AboutUser.getAllAboutUser()
        .then((data) => {
          this.aboutUser = data.data.data;
          this.getUserSetting(data.data.data);
        })
        .then((err) => {});
    },
    // setNumberMenuItem() {
    //     this.countNumber = this.countNumber + 1
    //     return this.countNumber
    // }
    ...mapActions("userSettingModule", ["getUserSetting"]),
  },
  mounted() {},
  created() {
    this.getAll();
    this.updateUserInfo();
  },
  computed: {
    ...mapState("menuModule", ["menuData"]),
    ...mapState("userSettingModule", ["userSetting"]),
    ...mapState("translationModule", ["dataLang"]),

    specialCrutch() {
      return [
        {
          menu__id: 13,
          menu__item: "menu_vehicles_nodriver_car",
          menu__parent_id: 11,
          menu__description: "Наземный",
          menu__position: 1,
          menu__href: "/transport/nodriver",
          menu__is_active: 1,
          menu__is_admin: 0,
          menu__is_superadmin: 0,
          menu__code: "name_menu_vehicles_nodriver_car",
          menu__number: "401",
          menu__css_class: null,
          menu__youtube_link: "https://www.youtube.com/watch?v=VZy0UWBb3W0",
        },
        {
          menu__id: 106,
          menu__item: "menu_vehicles_water",
          menu__parent_id: 11,
          menu__description: "Водный",
          menu__position: 8,
          menu__href: "/",
          menu__is_active: 1,
          menu__is_admin: 0,
          menu__is_superadmin: 0,
          menu__code: null,
          menu__number: "402",
          menu__css_class: "grey",
          menu__youtube_link: null,
        },
        {
          menu__id: 105,
          menu__item: "menu_vehicles_air",
          menu__parent_id: 11,
          menu__description: "Воздушный",
          menu__position: 7,
          menu__href: "/",
          menu__is_active: 1,
          menu__is_admin: 0,
          menu__is_superadmin: 0,
          menu__code: null,
          menu__number: "403",
          menu__css_class: "grey",
          menu__youtube_link: null,
        },
        {
          menu__id: 70,
          menu__item: "menu_vehicles_archive",
          menu__parent_id: 11,
          menu__description: "Архив транспорта",
          menu__position: 9,
          menu__href: "/transport/archive",
          menu__is_active: 1,
          menu__is_admin: 0,
          menu__is_superadmin: 0,
          menu__code: "name_menu_transport_archive",
          menu__number: "404",
          menu__css_class: null,
          menu__youtube_link: null,
        },
        {
          menu__id: 101,
          menu__item: "menu_vehicles_storehouse",
          menu__parent_id: 11,
          menu__description: "Склад",
          menu__position: 10,
          menu__href: "/development",
          menu__is_active: 1,
          menu__is_admin: 0,
          menu__is_superadmin: 0,
          menu__code: null,
          menu__number: "405",
          menu__css_class: "grey",
          menu__youtube_link: null,
        },
      ];
    },
    // setNumberMenuItem: {
    //   get() {
    //     return this.countNumber
    //   },
    //   set(index) {
    //
    //     this.countNumber + 1
    //   },
    // },
  },
  directives: {
    ClickOutside,
  },
};
</script>
